import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import SideNavbar from './helpers/SideNavbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLightbulb, faCheck, faImage, faImages, faStar, faUpload, faSpinner, faEdit, faExclamationTriangle, faChartBar, faLineChart, faNewspaper, faDownload } from '@fortawesome/free-solid-svg-icons';
import { FaLinkedin, FaFacebook, FaInstagram } from 'react-icons/fa';
import Swal from 'sweetalert2';
import { Modal, Button } from "react-bootstrap";
import TimezoneSelect from 'react-timezone-select';
import { Link, useNavigate } from 'react-router-dom';
import moment from 'moment-timezone';
import { useFeatureLimits } from './FeatureLimits/FeatureLimitsProvider';
import { FEATURE_NAMES } from '../apis/featureLimits';
import { validatePlatformSettings } from '../utils/platformValidation';
import { getAllActivePlatforms, formatPlatformNamesForButton, formatPlatformNamesForAlert } from '../utils/platformUtils';
import { validateInstagramImageFile, validateInstagramImageUrl, resizeForInstagram, blobToFile } from '../utils/instagramValidation';

const ExceptionalScheduleForm = () => {
    const navigate = useNavigate();
    const { logFeatureUsage, checkFeatureAccess } = useFeatureLimits();
    const [customPrompt, setCustomPrompt] = useState('');
    const [aiGeneratedContent, setAiGeneratedContent] = useState('');
    const [isGenerating, setIsGenerating] = useState(false);
    const [scheduleForLater, setScheduleForLater] = useState(false);
    const [scheduledDate, setScheduledDate] = useState('');
    const [timezone, setTimezone] = useState(null);
    
    // Helper function to get current date/time in local timezone for datetime-local input
    const getCurrentLocalDateTime = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };
    
    // Helper function to get max date (end of current year + 1 year) for datetime-local input
    const getMaxLocalDateTime = () => {
        const now = new Date();
        const maxYear = now.getFullYear() + 1; // Allow scheduling up to 1 year ahead
        const month = '12';
        const day = '31';
        const hours = '23';
        const minutes = '59';
        return `${maxYear}-${month}-${day}T${hours}:${minutes}`;
    };
    const [isScheduling, setIsScheduling] = useState(false);
    const [isPublishing, setIsPublishing] = useState(false);
    const [showHolidayModal, setShowHolidayModal] = useState(false);
    const [selectedHoliday, setSelectedHoliday] = useState('');
    const [holidayList, setHolidayList] = useState([]);
    const [countries, setCountries] = useState([]);
    const [countryCode, setCountryCode] = useState([]);
    const [fetchedImages, setFetchedImages] = useState([]);
    const [isFetchingImages, setIsFetchingImages] = useState(false);
    const [isRefreshingImages, setIsRefreshingImages] = useState(false); // Loading state for Refresh button
    const [isCraftingVisual, setIsCraftingVisual] = useState(false); // Loading state for Craft Visual button
    const [selectedImageUrl, setSelectedImageUrl] = useState(null);
    const [imageKeywords, setImageKeywords] = useState('');
    const [isImageModalOpen, setIsImageModalOpen] = useState(false);
    const [isMaximized, setIsMaximized] = useState(false);
    const [image, setImage] = useState(null);
    const [selectedImagename, setSelectedImagename] = useState('');
    const [imagePreview, setImagePreview] = useState(null);
    const [videoPreview, setVideoPreview] = useState(null);
    const fileInputRef = useRef(null);
    const [fileInputKey, setFileInputKey] = useState(0);
    const [error, setError] = useState('');
    const [enabledPlatforms, setEnabledPlatforms] = useState([]);
    const [platformsLoading, setPlatformsLoading] = useState(true);
    const [selectedPlatforms, setSelectedPlatforms] = useState([]); // Array of platform codes: ['linkedin', 'facebook', 'instagram']

    const UserID = localStorage.getItem("UserID");
    const accessToken = localStorage.getItem('AccessToken');
    const tokenID = localStorage.getItem('Tokenid');
    const userProfile = JSON.parse(localStorage.getItem("userProfile"));
    const AccountType = localStorage.getItem('AccountType');
    const SelectedUserEmail = localStorage.getItem('UserEmail');
    const SelectedUserEmail1 = localStorage.getItem('Email');
    const SelectedUserAccountId = localStorage.getItem('SelectedUserAccountId');
    const RoleID = localStorage.getItem('RoleID');

    const AccountId = userProfile ? userProfile[0].AccountId : null;
    const userId = tokenID;
    const LinkedinEmail = RoleID == 2 ? SelectedUserEmail1 : SelectedUserEmail;

    // Fetch countries
    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/countries`);
                setCountries(response.data);
            } catch (error) {
                console.error("Error fetching countries:", error);
            }
        };
        fetchCountries();
    }, []);


    // Fetch platforms based on AccountType
    useEffect(() => {
        const fetchPlatforms = async () => {
            setPlatformsLoading(true);
            
            // For User accounts, automatically use LinkedIn only (no UI needed)
            if (AccountType === 'User' || AccountType === 'user') {
                setSelectedPlatforms(['linkedin']);
                setEnabledPlatforms([{ name: 'LinkedIn', code: 'linkedin' }]);
                setPlatformsLoading(false);
                return;
            }
            
            // For Page accounts, fetch all active platforms and show selection UI
            const platforms = await getAllActivePlatforms();
            setEnabledPlatforms(platforms);
            // Default to all platforms selected
            if (platforms.length > 0) {
                setSelectedPlatforms(platforms.map(p => p.code));
            }
            setPlatformsLoading(false);
        };
        fetchPlatforms();
    }, [AccountType]);

    // Set default scheduled date and timezone when scheduleForLater is enabled
    useEffect(() => {
        if (scheduleForLater && !scheduledDate) {
            const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const defaultDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;
            setScheduledDate(defaultDateTime);
            if (!timezone) {
                setTimezone(userTimezone);
            }
        }
    }, [scheduleForLater, scheduledDate, timezone]);

    // Fetch holidays
    useEffect(() => {
        const fetchHolidays = async () => {
            if (countries.length === 0) return;
            let selectedCountryCodes = [];
            if (Array.isArray(countryCode) && countryCode.length > 0) {
                selectedCountryCodes = countryCode.map(selected => {
                    const match = countries.find(c => c.CountryName === selected.value);
                    if (match) {
                        return match.CountryCode;
                    }
                    console.warn(`Country not found in countries list: ${selected.value}`);
                    return null;
                }).filter(Boolean);
            }
            if (selectedCountryCodes.length === 0) {
                selectedCountryCodes = ['US'];
                console.log('No country preference found, defaulting to US');
            }
            try {
                const countryParam = selectedCountryCodes.map(code => code.trim()).join(',');
                console.log('Fetching holidays for countries:', countryParam);
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/holidays?country=${countryParam}`);
                console.log(`Fetched ${response.data.length} holidays`);
                setHolidayList(response.data);
            } catch (error) {
                console.error("Error fetching holidays:", error);
            }
        };
        fetchHolidays();
    }, [countryCode, countries]);

    // Get user's timezone and today's date for holiday filtering
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const todayDate = new Date().toLocaleDateString('en-CA'); // YYYY-MM-DD format in user's timezone

    const holidayOptions = holidayList
        .filter(holiday => {
            // Parse holiday date - convert to YYYY-MM-DD in user's timezone
            let holidayDateStr;
            if (holiday.Date instanceof Date) {
                // Convert Date object to YYYY-MM-DD in user's timezone
                holidayDateStr = holiday.Date.toLocaleDateString('en-CA', { timeZone: userTimezone });
            } else {
                // If it's a string (like "2025-11-11"), parse it as a date and convert to user's timezone
                const holidayDate = new Date(holiday.Date);
                holidayDateStr = holidayDate.toLocaleDateString('en-CA', { timeZone: userTimezone });
            }
            
            // Compare dates (YYYY-MM-DD format allows direct string comparison)
            return holidayDateStr >= todayDate;
        })
        .map(holiday => ({
            
            
          
                value: holiday.Name,
                label: `${holiday.Name} (${moment.utc(holiday.Date).format("MMM DD, YYYY")})`
        }));

    // Extract keywords from content for better image search
    const extractKeywordsFromContent = (content, originalPrompt) => {
        const keywords = [];
        
        // 1. Always include the original prompt (most relevant)
        if (originalPrompt?.trim()) {
            const promptWords = originalPrompt
                .split(/\s+/)
                .filter(word => word.length > 3 && !['the', 'and', 'for', 'are', 'but', 'not', 'you', 'all', 'can', 'her', 'was', 'one', 'our', 'out', 'day', 'get', 'has', 'him', 'his', 'how', 'its', 'may', 'new', 'now', 'old', 'see', 'two', 'way', 'who', 'boy', 'did', 'she', 'use', 'her', 'many', 'than', 'them'].includes(word.toLowerCase()))
                .slice(0, 5);
            keywords.push(...promptWords);
        }
        
        // 2. Extract hashtags from content
        const hashtags = content.match(/#[\w]+/g) || [];
        keywords.push(...hashtags.map(tag => tag.replace('#', '')));
        
        // 3. Extract key nouns/phrases from content
        const capitalizedWords = content.match(/\b[A-Z][a-z]+\b/g) || [];
        keywords.push(...capitalizedWords.slice(0, 3));
        
        // Remove duplicates and limit to 5-7 keywords
        const uniqueKeywords = [...new Set(keywords)].slice(0, 7);
        return uniqueKeywords.filter(k => k && k.length > 2);
    };

    // Function to fetch images with current keywords
    const fetchImagesWithKeywords = async (isRefresh = false) => {
        if (!aiGeneratedContent?.trim()) {
            return;
        }
        
        // Set appropriate loading state based on which button was clicked
        if (isRefresh) {
            setIsRefreshingImages(true);
        } else if (imageKeywords?.trim()) {
            setIsCraftingVisual(true);
        } else {
            setIsFetchingImages(true);
        }
        
        try {
            // If user has manually entered keywords, use those
            if (imageKeywords?.trim() && !isRefresh) {
                const manualKeywords = imageKeywords.split(',').map(k => k.trim()).filter(k => k);
                await fetchImagesForTags(manualKeywords);
                setIsCraftingVisual(false);
                return;
            }
            
            // Otherwise, use improved automatic extraction
            const extractedKeywords = extractKeywordsFromContent(aiGeneratedContent, customPrompt);
            console.log('Extracted keywords for images:', extractedKeywords);
            
            if (extractedKeywords.length > 0) {
                await fetchImagesForTags(extractedKeywords);
            } else {
                // Fallback: try to generate a title from the content
                try {
                    const titleResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/generate-title`, {
                        content: aiGeneratedContent,
                    });
                    const generatedTitle = titleResponse.data.title || '';
                    if (generatedTitle) {
                        await fetchImagesForTags([generatedTitle]);
                    } else {
                        setFetchedImages([]);
                    }
                } catch (error) {
                    console.error('Error generating title:', error);
                    setFetchedImages([]);
                }
            }
        } catch (error) {
            console.error('Error fetching images:', error);
            setFetchedImages([]);
        } finally {
            setIsFetchingImages(false);
            setIsRefreshingImages(false);
            setIsCraftingVisual(false);
        }
    };

    // Fetch images when AI content is generated
    useEffect(() => {
        if (aiGeneratedContent?.trim() && !imageKeywords?.trim()) {
            fetchImagesWithKeywords();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [aiGeneratedContent, customPrompt]);

    const validateImage = async (url) => {
        return new Promise((resolve) => {
            const img = new Image();
            const timeout = setTimeout(() => {
                resolve(null); // Timeout after 3 seconds
            }, 3000);
            
            img.onload = () => {
                clearTimeout(timeout);
                resolve(url);
            };
            img.onerror = () => {
                clearTimeout(timeout);
                resolve(null);
            };
            img.src = url;
        });
    };

    const fetchImagesForTags = async (tags) => {
        if (!tags.length) return;

        try {
            const query = tags.join(" ");
            const response = await axios.get("https://www.googleapis.com/customsearch/v1", {
                params: {
                    key: process.env.REACT_APP_GOOGLE_API_KEY,
                    cx: process.env.REACT_APP_GOOGLE_CSE_ID,
                    q: query,
                    searchType: "image",
                    num: 10,
                    rights: 'cc_publicdomain,cc_attribute',
                    safe: 'active',
                },
            });

            if (response.data.items) {
                // Validate only first 8 images in parallel (faster), with timeout
                const itemsToValidate = response.data.items.slice(0, 8);
                const imageLinks = await Promise.all(
                    itemsToValidate.map((item) => validateImage(item.link))
                );
                const validImages = imageLinks.filter((link) => link !== null);

                if (validImages.length === 0) {
                    setFetchedImages([]);
                } else {
                    setFetchedImages(validImages);
                }
            } else {
                setFetchedImages([]);
            }
        } catch (error) {
            console.error("Error fetching images:", error);
            setFetchedImages([]);
        }
    };

    const generateContent = async () => {
        try {
            const prompt = customPrompt;
            
            if (!prompt.trim()) {
            Swal.fire({
                    icon: 'warning',
                    title: 'Prompt Required',
                    text: 'Please select a holiday or enter a prompt',
                    showConfirmButton: true,
                });
                return;
            }

            setIsGenerating(true);
            setImageKeywords(''); // Clear image keywords when generating new content
            
            // Use the same API endpoint as CreatePostPage
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/api/generateAIContentinUpdatepost`,
                { UserID, Prompts: prompt },
                { headers: { 'Content-Type': 'application/json' } }
            );

            const newContent = response.data.content;
            setAiGeneratedContent(newContent);
        } catch (error) {
            console.error('Error generating content:', error);
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error generating AI content',
                text: error.response?.data?.message || 'An error occurred while generating content. Please try again.',
                showConfirmButton: true,
            });
        } finally {
            setIsGenerating(false);
        }
    };

    const handleHolidaySelect = (holiday) => {
        setSelectedHoliday(holiday.value);
        setCustomPrompt(`Generate/Draft a creative ${holiday.value} message`);
        setShowHolidayModal(false);
        
        // Find the original holiday object from holidayList to get the date
        const originalHoliday = holidayList.find(h => h.Name === holiday.value);
        if (originalHoliday && originalHoliday.Date) {
            // Get user's timezone
            const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            
            // Parse the holiday date - extract date components to avoid timezone issues
            let dateStr;
            let holidayYear, holidayMonth, holidayDay;
            
            if (originalHoliday.Date instanceof Date) {
                // If it's a Date object, extract UTC date components
                const date = originalHoliday.Date;
                holidayYear = date.getUTCFullYear();
                holidayMonth = String(date.getUTCMonth() + 1).padStart(2, '0');
                holidayDay = String(date.getUTCDate()).padStart(2, '0');
                dateStr = `${holidayYear}-${holidayMonth}-${holidayDay}`;
            } else {
                // Use moment.utc to parse the date and get the correct year (same as used in display)
                // This ensures consistency with how the date is displayed in the holiday list
                // Try parsing with moment.utc first (handles ISO strings and common formats)
                let holidayMoment = moment.utc(originalHoliday.Date);
                
                // If that doesn't work, try parsing as a string with explicit format
                if (!holidayMoment.isValid()) {
                    const dateString = originalHoliday.Date.toString();
                    // Try common date formats
                    holidayMoment = moment.utc(dateString, ['YYYY-MM-DD', 'MM/DD/YYYY', 'DD-MM-YYYY', 'YYYY/MM/DD'], true);
                }
                
                if (holidayMoment.isValid()) {
                    // Get the year, month, and day from the parsed moment
                    holidayYear = holidayMoment.year();
                    holidayMonth = holidayMoment.format('MM');
                    holidayDay = holidayMoment.format('DD');
                    dateStr = holidayMoment.format('YYYY-MM-DD');
                    console.log('✅ Holiday date parsed:', { original: originalHoliday.Date, parsed: dateStr, year: holidayYear });
                } else {
                    // Fallback: try to extract YYYY-MM-DD format directly from the string
                    const dateString = originalHoliday.Date.toString();
                    const dateMatch = dateString.match(/(\d{4})-(\d{2})-(\d{2})/);
                    if (dateMatch) {
                        holidayYear = parseInt(dateMatch[1]);
                        holidayMonth = dateMatch[2];
                        holidayDay = dateMatch[3];
                        dateStr = `${dateMatch[1]}-${dateMatch[2]}-${dateMatch[3]}`;
                        console.log('✅ Holiday date extracted via regex:', { original: dateString, extracted: dateStr, year: holidayYear });
                    } else {
                        // Last resort: parse as UTC to get the correct date
                        const holidayDate = new Date(originalHoliday.Date);
                        holidayYear = holidayDate.getUTCFullYear();
                        holidayMonth = String(holidayDate.getUTCMonth() + 1).padStart(2, '0');
                        holidayDay = String(holidayDate.getUTCDate()).padStart(2, '0');
                        dateStr = `${holidayYear}-${holidayMonth}-${holidayDay}`;
                        console.log('⚠️ Holiday date parsed via Date object:', { original: originalHoliday.Date, parsed: dateStr, year: holidayYear });
                    }
                }
            }
            
            // Smart year adjustment: use current year for past holidays, or next year if date has passed this year
            const now = new Date();
            const currentYear = now.getFullYear();
            const currentMonth = now.getMonth() + 1; // getMonth() returns 0-11
            const currentDay = now.getDate();
            
            const holidayMonthNum = parseInt(holidayMonth);
            const holidayDayNum = parseInt(holidayDay);
            
            // If holiday is already in a future year, use that year (no adjustment needed)
            if (holidayYear > currentYear) {
                // Keep the original future year
                console.log('📅 Using holiday\'s original future year:', { 
                    originalYear: holidayYear, 
                    finalDate: dateStr 
                });
            } else if (holidayYear < currentYear) {
                // Holiday is from a past year - use current year for next occurrence
                dateStr = `${currentYear}-${holidayMonth}-${holidayDay}`;
                console.log('📅 Using current year for past holiday:', { 
                    originalYear: holidayYear, 
                    adjustedYear: currentYear, 
                    finalDate: dateStr 
                });
            } else {
                // Holiday is in current year - check if date has passed
                const hasPassed = holidayMonthNum < currentMonth || 
                                (holidayMonthNum === currentMonth && holidayDayNum < currentDay);
                
                if (hasPassed) {
                    // Holiday date has passed this year, use next year
                    const nextYear = currentYear + 1;
                    dateStr = `${nextYear}-${holidayMonth}-${holidayDay}`;
                    console.log('📅 Adjusted holiday date to next year (date has passed this year):', { 
                        originalYear: holidayYear, 
                        adjustedYear: nextYear, 
                        finalDate: dateStr 
                    });
                } else {
                    // Holiday date hasn't passed yet this year, use current year
                    dateStr = `${currentYear}-${holidayMonth}-${holidayDay}`;
                    console.log('📅 Using current year (date hasn\'t passed):', { 
                        originalYear: holidayYear, 
                        finalYear: currentYear, 
                        finalDate: dateStr 
                    });
                }
            }
            
            // Format for datetime-local input (YYYY-MM-DDTHH:mm) - set to 6 AM
            // The datetime-local value will be interpreted in the selected timezone when scheduling
            const formattedDateTime = `${dateStr}T06:00`;
            
            console.log('📅 Setting scheduled date:', {
                holidayName: holiday.value,
                originalDate: originalHoliday.Date,
                parsedDateStr: dateStr,
                formattedDateTime: formattedDateTime
            });
            
            // Set schedule date and timezone
            // Pass timezone string directly - TimezoneSelect will format it automatically (like Challenges.jsx)
            setScheduledDate(formattedDateTime);
            setTimezone(userTimezone);
            setScheduleForLater(true);
        }
    };

    const toUnicodeBold = (text) => {
        const boldMap = {
            A: '𝗔', B: '𝗕', C: '𝗖', D: '𝗗', E: '𝗘', F: '𝗙', G: '𝗚', H: '𝗛', I: '𝗜', J: '𝗝', K: '𝗞', L: '𝗟', M: '𝗠',
            N: '𝗡', O: '𝗢', P: '𝗣', Q: '𝗤', R: '𝗥', S: '𝗦', T: '𝗧', U: '𝗨', V: '𝗩', W: '𝗪', X: '𝗫', Y: '𝗬', Z: '𝗭',
            a: '𝗮', b: '𝗯', c: '𝗰', d: '𝗱', e: '𝗲', f: '𝗳', g: '𝗴', h: '𝗵', i: '𝗶', j: '𝗷', k: '𝗸', l: '𝗹', m: '𝗺',
            n: '𝗻', o: '𝗼', p: '𝗽', q: '𝗾', r: '𝗿', s: '𝘀', t: '𝘁', u: '𝘂', v: '𝘃', w: '𝘄', x: '𝘅', y: '𝘆', z: '𝘇',
            0: '𝟬', 1: '𝟭', 2: '𝟮', 3: '𝟯', 4: '𝟰', 5: '𝟱', 6: '𝟲', 7: '𝟳', 8: '𝟴', 9: '𝟵'
        };

        return text.replace(/\*\*(.*?)\*\*/g, (_, match) => {
            return match
                .split(' ')
                .map(word => word.startsWith('#') ? word : word.split('').map(char => boldMap[char] || char).join(''))
                .join(' ');
        });
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        
        // If no file selected (user cancelled), clear everything
        if (!file) {
            setImage(null);
            setSelectedImagename('');
            setImagePreview(null);
            setVideoPreview(null);
            return;
        }
        
        const maxSize = 50 * 1024 * 1024;

        if (file.size > maxSize) {
            Swal.fire({
                icon: 'error',
                title: 'File Size Exceeded',
                text: 'The file size should not exceed 50 MB.',
                showConfirmButton: true,
            });
            setImage(null);
            setSelectedImagename('');
            setImagePreview(null);
            setVideoPreview(null);
            return;
        }
        
        // File is valid, proceed with setting it
        setImage(file);
        setSelectedImagename(file.name || '');
        setSelectedImageUrl(null);

        // Create preview for image files
        if (file.type && file.type.startsWith('image/')) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const result = e.target?.result || reader.result;
                if (result) {
                    setImagePreview(result);
                    setVideoPreview(null); // Clear video preview when image is selected
                }
            };
            reader.onerror = () => {
                console.error('Error reading image file');
                setImagePreview(null);
            };
            reader.readAsDataURL(file);
        } else if (file.type && file.type.startsWith('video/')) {
            // Create preview for video files
            const reader = new FileReader();
            reader.onload = (e) => {
                const result = e.target?.result || reader.result;
                if (result) {
                    setVideoPreview(result);
                    setImagePreview(null); // Clear image preview when video is selected
                }
            };
            reader.onerror = () => {
                console.error('Error reading video file');
                setVideoPreview(null);
            };
            reader.readAsDataURL(file);
        } else {
            setImagePreview(null);
            setVideoPreview(null);
        }
    };

    const handleSelectSuggestedImage = (imageUrl) => {
        setSelectedImageUrl(imageUrl);
        setSelectedImagename(imageUrl);
        setImage(null);
        setImagePreview(null);
        setVideoPreview(null);
    };

    const handleDownloadImage = async (imageUrl, e) => {
        e.stopPropagation();
        try {
            // Fetch the image
            const response = await fetch(imageUrl);
            const blob = await response.blob();
            
            // Create a download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            
            // Extract filename from URL or use default
            const urlParts = imageUrl.split('/');
            const filename = urlParts[urlParts.length - 1].split('?')[0] || 'downloaded-image.jpg';
            link.download = filename;
            
            // Trigger download
            document.body.appendChild(link);
            link.click();
            
            // Cleanup
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading image:', error);
            Swal.fire({
                icon: 'error',
                title: 'Download Failed',
                text: 'Failed to download the image. Please try again.',
                confirmButtonText: 'OK',
                confirmButtonColor: '#2e3192'
            });
        }
    };

    const handlePlatformToggle = (platformCode) => {
        if (selectedPlatforms.includes(platformCode)) {
            // Prevent unchecking if it's the last selected platform
            if (selectedPlatforms.length > 1) {
                setSelectedPlatforms(selectedPlatforms.filter(p => p !== platformCode));
            } else {
                Swal.fire({
                    icon: 'warning',
                    title: 'At Least One Platform Required',
                    text: 'Please select at least one platform to post to.',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#2e3192',
                    timer: 2000
                });
            }
        } else {
            setSelectedPlatforms([...selectedPlatforms, platformCode]);
        }
    };

    const handleSchedulePost = async () => {
        setIsScheduling(true);
        try {
            if (!accessToken || !userId) {
                throw new Error('Access Token or User ID is missing');
            }

            // Validate that at least one platform is selected
            if (!selectedPlatforms || selectedPlatforms.length === 0) {
                Swal.fire({
                    icon: 'warning',
                    title: 'No Platform Selected',
                    text: 'Please select at least one platform to schedule to.',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#2e3192',
                    timer: 2000
                });
                setIsScheduling(false);
                return;
            }

            // Check if Instagram is selected and require image
            const isInstagramEnabled = selectedPlatforms.includes('instagram');
            const hasImage = !!(image || selectedImageUrl);
            
            if (isInstagramEnabled && !hasImage) {
                await Swal.fire({
                    icon: 'error',
                    title: 'Image Required for Instagram',
                    html: `
                        <div style="text-align: left;">
                            <p style="margin-bottom: 15px;"><strong>Instagram requires an image to post.</strong></p>
                            <p style="margin-bottom: 20px; color: #666;">Please add an image to your post before scheduling to Instagram.</p>
                        </div>
                    `,
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#2e3192',
                });
                setIsScheduling(false);
                return;
            }

            // Validate Instagram image aspect ratio if Instagram is enabled and image exists
            if (isInstagramEnabled && hasImage) {
                try {
                    let validationResult;
                    
                    if (image) {
                        // Validate uploaded file
                        validationResult = await validateInstagramImageFile(image);
                    } else if (selectedImageUrl) {
                        // Validate selected image URL
                        validationResult = await validateInstagramImageUrl(selectedImageUrl);
                    }
                    
                    if (validationResult && !validationResult.isValid) {
                        await Swal.fire({
                            icon: 'error',
                            title: 'Invalid Image Aspect Ratio for Instagram',
                            html: `
                                <div style="text-align: left;">
                                    <p style="margin-bottom: 15px;"><strong>${validationResult.error || 'Image does not meet Instagram requirements.'}</strong></p>
                                    <p style="margin-bottom: 20px; color: #666;">Instagram requires images with aspect ratios between 0.8:1 and 1.91:1 (approximately 4:5 portrait to 1.91:1 landscape).</p>
                                    <p style="color: #666;">Please select a different image with a valid aspect ratio.</p>
                                </div>
                            `,
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#2e3192',
                        });
                        setIsScheduling(false);
                        return;
                    }
                } catch (validationError) {
                    console.error('Error validating Instagram image:', validationError);
                    // If validation fails due to technical issues, warn but allow to proceed
                    // (backend will catch it anyway)
                    const result = await Swal.fire({
                        icon: 'warning',
                        title: 'Image Validation Warning',
                        text: 'Unable to validate image aspect ratio. The post will be scheduled, but Instagram may reject it if the aspect ratio is invalid.',
                        confirmButtonText: 'Continue',
                        confirmButtonColor: '#2e3192',
                        showCancelButton: true,
                        cancelButtonText: 'Cancel',
                        cancelButtonColor: '#6c757d',
                    });
                    
                    if (!result.isConfirmed) {
                        setIsScheduling(false);
                        return;
                    }
                }
            }

            if (!scheduledDate) {
            Swal.fire({
                    position: 'center',
                    icon: 'warning',
                    title: 'Schedule Date Required',
                    text: 'Please select a date and time for scheduling.',
                    showConfirmButton: true,
                });
                setIsScheduling(false);
                return;
            }

            // Handle both string and object formats for timezone
            const timezoneValue = typeof timezone === 'string' ? timezone : timezone?.value;
            
            if (!timezone || !timezoneValue) {
                Swal.fire({
                    position: 'center',
                    icon: 'warning',
                    title: 'Timezone Required',
                    text: 'Please select a timezone.',
                    showConfirmButton: true,
                });
                setIsScheduling(false);
                return;
            }

            // Validate that the scheduled date is not in the past
            // Parse the datetime-local string (format: "YYYY-MM-DDTHH:mm")
            const dateStr = scheduledDate; // e.g., "2025-11-06T23:35"
            const [datePart, timePart] = dateStr.split('T');
            const [year, month, day] = datePart.split('-').map(Number);
            const [hour, minute] = (timePart || '').split(':').map(Number);
            
            // Create scheduledDateTime moment in the selected timezone (like CreatePostPage backend expects)
            // Interpret the date/time from datetime-local input as being in the selected timezone
            const scheduledDateTimeStr = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')} ${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
            const scheduledMoment = moment.tz(scheduledDateTimeStr, 'YYYY-MM-DD HH:mm', timezoneValue);
            
            // Get current moment in the selected timezone
            const nowInTimeZone = moment.tz(timezoneValue);
            
            // Check if scheduled time is in the past using moment comparison
            if (scheduledMoment.isBefore(nowInTimeZone) || scheduledMoment.isSame(nowInTimeZone)) {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Invalid Schedule Time',
                    text: 'Please select a date and time in the future. The scheduled time cannot be in the past.',
                    showConfirmButton: true,
                });
                setIsScheduling(false);
                return;
            }

            const accessCheck = await checkFeatureAccess(FEATURE_NAMES.KNACK_MOMENTS);
            if (!accessCheck.canProceed) {
                const msg = `You have reached your limit for Knack Moments. ${accessCheck.error || 'Please upgrade to continue.'}`;
                setError(msg);
                Swal.fire({
                    icon: 'warning',
                    title: 'Limit Exceeded',
                    text: msg,
                    confirmButtonText: 'OK',
                });
                setIsScheduling(false);
                return;
            }

            let contentToUse = aiGeneratedContent;

            const plainTextContent = contentToUse
                ? toUnicodeBold(contentToUse)
                    .replace(/<\/?br\s*\/?>/g, '\n')
                    .replace(/<\/?p>/g, '\n')
                    .replace(/<\/?[^>]+(>|$)/g, '')
                : '';

            let imageAsset = null;
            let imageUrlToSave = null; // Azure URL or external URL to persist in DB
            let videoUrlToSave = null; // Video URL for database saving

            if (image) {
                let imageToUpload = image;

                // ✅ Resize image to 1080x1080 (1:1) for Instagram BEFORE uploading
                if (isInstagramEnabled && image.type.startsWith('image/')) {
                    try {
                        console.log('📐 Resizing image to 1080x1080 (1:1) for Instagram...');
                        const resizedBlob = await resizeForInstagram(image);
                        
                        // Validate the resized blob
                        if (!resizedBlob || resizedBlob.size === 0) {
                            throw new Error('Resized image is empty or invalid');
                        }
                        
                        console.log('✅ Resized blob size:', resizedBlob.size, 'bytes');
                        imageToUpload = blobToFile(resizedBlob, `instagram-${Date.now()}.jpg`);
                        
                        // Validate the file
                        if (!imageToUpload || imageToUpload.size === 0) {
                            throw new Error('Failed to convert resized blob to file');
                        }
                        
                        console.log('✅ Image resized successfully for Instagram (1080x1080), file size:', imageToUpload.size);
                    } catch (resizeError) {
                        console.error('❌ Error resizing image for Instagram:', resizeError);
                        await Swal.fire({
                            icon: 'error',
                            title: 'Image Resize Failed',
                            html: `
                                <div style="text-align: left;">
                                    <p style="margin-bottom: 10px;"><strong>Failed to resize image for Instagram:</strong></p>
                                    <p style="margin-bottom: 10px; color: #666;">${resizeError.message || 'The image may be corrupted or invalid.'}</p>
                                    <p style="margin-bottom: 10px; color: #666;">Please try:</p>
                                    <ol style="margin-left: 20px; padding-left: 10px; color: #666;">
                                        <li>Selecting a different image</li>
                                        <li>Or uploading an image from your device</li>
                                    </ol>
                                </div>
                            `,
                            showConfirmButton: true,
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#2e3192'
                        });
                        setIsScheduling(false);
                        return;
                    }
                }

                const formData = new FormData();
                formData.append('file', imageToUpload); // Use resized image if Instagram is enabled
                formData.append('userId', userId);

                if (image.type.startsWith('image/')) {
                    try {
                        // For scheduled posts, use blob storage upload like CreatePostPage
                        const imageUploadResponse = await axios.post(
                            `${process.env.REACT_APP_API_BASE_URL}/api/upload-image-blob`,
                            formData,
                            {
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                },
                            }
                        );
                        imageAsset = imageUploadResponse.data.imageUrl;
                        imageUrlToSave = imageAsset;
                    } catch (error) {
                        console.error('❌ Error uploading image to blob storage:', error);
                        console.error('❌ Error details:', {
                            message: error.message,
                            response: error.response?.data,
                            status: error.response?.status
                        });
                        
                        // Provide more specific error message
                        let errorMessage = 'Image upload failed.';
                        let errorDetails = '';
                        
                        if (error.response?.status === 413) {
                            errorMessage = 'Image file too large.';
                            errorDetails = 'The image file exceeds the maximum size limit.';
                        } else if (error.response?.status === 400) {
                            errorMessage = 'Invalid image format.';
                            errorDetails = 'The image format is not supported or the file is corrupted.';
                        } else if (error.response?.data?.message) {
                            errorMessage = error.response.data.message;
                            errorDetails = error.message || 'Please try again or use a different image.';
                        } else {
                            errorDetails = error.message || 'An unexpected error occurred.';
                        }
                        
                        await Swal.fire({
                            icon: 'error',
                            title: 'Image Upload Failed',
                            html: `
                                <div style="text-align: left;">
                                    <p style="margin-bottom: 10px;"><strong>${errorMessage}</strong></p>
                                    ${errorDetails ? `<p style="margin-bottom: 15px; color: #666;">${errorDetails}</p>` : ''}
                                    <p style="margin-bottom: 10px; color: #666;"><strong>Please try the following:</strong></p>
                                    <ol style="margin-left: 20px; padding-left: 10px; color: #666;">
                                        <li>Select a different image</li>
                                        <li>Or try again in a few moments</li>
                                    </ol>
                                </div>
                            `,
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#2e3192',
                            width: '500px'
                        });
                        setIsScheduling(false);
                        return;
                    }
                } else if (image.type.startsWith('video/')) {
                    try {
                        // Upload video to blob storage for database saving
                        const videoUploadResponse = await axios.post(
                            `${process.env.REACT_APP_API_BASE_URL}/api/upload-image-blob`,
                            formData,
                            {
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                },
                            }
                        );
                        videoUrlToSave = videoUploadResponse.data.imageUrl;
                    } catch (error) {
                        console.error('Error uploading video to blob storage:', error);
                        await Swal.fire({
                            icon: 'error',
                            title: 'Video Upload Failed',
                            html: `
                                <div style="text-align: left;">
                                    <p><strong>Video upload failed. Please try the following:</strong></p>
                                    <ol style="margin-left: 20px; padding-left: 10px;">
                                        <li>Download the video to your local Downloads folder</li>
                                        <li>Remove the video from the media section</li>
                                        <li>Re-upload the video from your local Downloads folder</li>
                                    </ol>
                                </div>
                            `,
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#2e3192'
                        });
                        setIsScheduling(false);
                        return;
                    }
                }
            } else if (selectedImageUrl) {
                try {
                    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/download-image?url=${encodeURIComponent(selectedImageUrl)}`);
                    if (!response.ok) {
                        throw new Error('Failed to download image');
                    }
                    const blob = await response.blob();
                    const fileName = `image_${Date.now()}.jpg`;
                    let file = new File([blob], fileName, { type: blob.type });

                    // ✅ Resize image to 1080x1080 (1:1) for Instagram BEFORE uploading
                    if (isInstagramEnabled) {
                        try {
                            console.log('📐 Resizing selected image to 1080x1080 (1:1) for Instagram...');
                            const resizedBlob = await resizeForInstagram(selectedImageUrl);
                            
                            // Validate the resized blob
                            if (!resizedBlob || resizedBlob.size === 0) {
                                throw new Error('Resized image is empty or invalid');
                            }
                            
                            console.log('✅ Resized blob size:', resizedBlob.size, 'bytes');
                            file = blobToFile(resizedBlob, `instagram-${Date.now()}.jpg`);
                            
                            // Validate the file
                            if (!file || file.size === 0) {
                                throw new Error('Failed to convert resized blob to file');
                            }
                            
                            console.log('✅ Selected image resized successfully for Instagram (1080x1080), file size:', file.size);
                        } catch (resizeError) {
                            console.error('❌ Error resizing selected image for Instagram:', resizeError);
                            // Try one more time with the downloaded blob directly
                            try {
                                console.log('🔄 Retrying resize with downloaded blob...');
                                const resizedBlob = await resizeForInstagram(file);
                                
                                // Validate the resized blob
                                if (!resizedBlob || resizedBlob.size === 0) {
                                    throw new Error('Resized image is empty or invalid on retry');
                                }
                                
                                file = blobToFile(resizedBlob, `instagram-${Date.now()}.jpg`);
                                
                                // Validate the file
                                if (!file || file.size === 0) {
                                    throw new Error('Failed to convert resized blob to file on retry');
                                }
                                
                                console.log('✅ Image resized successfully on retry, file size:', file.size);
                            } catch (retryError) {
                                console.error('❌ Retry also failed:', retryError);
                                await Swal.fire({
                                    icon: 'error',
                                    title: 'Image Resize Failed',
                                    html: `
                                        <div style="text-align: left;">
                                            <p style="margin-bottom: 10px;"><strong>Failed to resize image for Instagram:</strong></p>
                                            <p style="margin-bottom: 10px; color: #666;">${resizeError.message || retryError.message || 'The image may be corrupted or invalid.'}</p>
                                            <p style="margin-bottom: 10px; color: #666;">Please try:</p>
                                            <ol style="margin-left: 20px; padding-left: 10px; color: #666;">
                                                <li>Selecting a different image</li>
                                                <li>Or uploading an image from your device</li>
                                            </ol>
                                        </div>
                                    `,
                                    showConfirmButton: true,
                                    confirmButtonText: 'OK',
                                    confirmButtonColor: '#2e3192'
                                });
                                setIsScheduling(false);
                                return;
                            }
                        }
                    }

                    const formData = new FormData();
                    formData.append('file', file); // Use resized file if Instagram is enabled
                    formData.append('userId', userId);

                    // For scheduled posts, use blob storage upload like CreatePostPage
                    const imageUploadResponse = await axios.post(
                        `${process.env.REACT_APP_API_BASE_URL}/api/upload-image-blob`,
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        }
                    );
                    imageAsset = imageUploadResponse.data.imageUrl;
                } catch (error) {
                    console.error('❌ Error downloading and uploading image:', error);
                    console.error('❌ Error details:', {
                        message: error.message,
                        response: error.response?.data,
                        status: error.response?.status
                    });
                    
                    // Provide more specific error message
                    let errorMessage = 'Image upload failed.';
                    let errorDetails = '';
                    
                    if (error.message?.includes('resize')) {
                        errorMessage = 'Failed to resize image for Instagram.';
                        errorDetails = 'The image could not be resized to the required format.';
                    } else if (error.message?.includes('download')) {
                        errorMessage = 'Failed to download image.';
                        errorDetails = 'Could not download the image from the server.';
                    } else if (error.response?.status === 413) {
                        errorMessage = 'Image file too large.';
                        errorDetails = 'The image file exceeds the maximum size limit.';
                    } else if (error.response?.status === 400) {
                        errorMessage = 'Invalid image format.';
                        errorDetails = 'The image format is not supported or the file is corrupted.';
                    } else if (error.response?.data?.message) {
                        errorMessage = error.response.data.message;
                        errorDetails = error.message || 'Please try again or use a different image.';
                    } else {
                        errorDetails = error.message || 'An unexpected error occurred.';
                    }
                    
                    await Swal.fire({
                        icon: 'error',
                        title: 'Image Upload Failed',
                        html: `
                            <div style="text-align: left;">
                                <p style="margin-bottom: 10px;"><strong>${errorMessage}</strong></p>
                                ${errorDetails ? `<p style="margin-bottom: 15px; color: #666;">${errorDetails}</p>` : ''}
                                <p style="margin-bottom: 10px; color: #666;"><strong>Please try the following:</strong></p>
                                <ol style="margin-left: 20px; padding-left: 10px; color: #666;">
                                    <li>Select a different image</li>
                                    <li>Or try again in a few moments</li>
                                </ol>
                            </div>
                        `,
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#2e3192',
                        width: '500px'
                    });
                    setIsScheduling(false);
                    return;
                }
            }

            // Format date and time using moment in the selected timezone (like CreatePostPage)
            // Use moment object directly to preserve timezone context
            const startDate = scheduledMoment.format('YYYY-MM-DD'); // YYYY-MM-DD format
            const scheduleTime = scheduledMoment.format('HH:mm'); // HH:mm format
            const dayName = scheduledMoment.format('dddd'); // Full day name (Monday, Tuesday, etc.)

            // Use selected platforms directly
            const platformsToSchedule = selectedPlatforms;

            const scheduleData = {
                Days: dayName, // Get day name
                ScheduleTime: scheduleTime, // HH:mm format
                StartDate: startDate, // YYYY-MM-DD format
                EndDate: startDate, // Same as StartDate for single post
                // Save the actual prompt text (holiday name or typed prompt)
                Prompt: selectedHoliday || customPrompt || 'custom',
                AccessToken: accessToken,
                Tokenid: userId,
                TimeZone: timezoneValue, // Note: TimeZone with capital Z
                Email: LinkedinEmail,
                AccountId: RoleID == 1 || RoleID == 4 ? AccountId : SelectedUserAccountId,
                UserID: UserID,
                Status: 'APPROVED',
                PromptType: 2,
                AccountType: AccountType,
                Content: plainTextContent, // Send the generated content
                Image: (image && image.type && image.type.startsWith('video/')) 
                    ? (videoUrlToSave || imageUrlToSave || 'uploaded') 
                    : (imageAsset || imageUrlToSave || selectedImageUrl || (image ? 'uploaded' : null)), // Send image/video info
                Video: (image && image.type && image.type.startsWith('video/')) 
                    ? (videoUrlToSave || 'uploaded') 
                    : null, // Send video info if it's a video
                customPrompt: customPrompt, // Send the custom prompt text
                platforms: platformsToSchedule // Send selected platforms array
            };

            const resp = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/api/create-post-schedule`,
                scheduleData,
                {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (resp.status === 200) {
                try {
                    await logFeatureUsage(FEATURE_NAMES.KNACK_MOMENTS, 1, JSON.stringify({
                        scheduleType: 'knack_moment_schedule',
                        scheduledDate: scheduledDate,
                        hasImage: !!(image || selectedImageUrl),
                    }));
                } catch (usageError) {
                    console.error('Error logging feature usage:', usageError);
                }

            // Format success message using moment in selected timezone
            const formattedScheduledTime = scheduledMoment.format('MMMM DD, YYYY [at] hh:mm A');
            
            Swal.fire({
                    position: 'center',
                icon: 'success',
                    title: 'Post Scheduled Successfully',
                    text: `Your Knack Moment has been scheduled for ${formattedScheduledTime}`,
                    showConfirmButton: false,
                timer: 3000,
                });

                // Reset form
                setCustomPrompt('');
                setAiGeneratedContent('');
                setSelectedImageUrl(null);
                setImage(null);
                setImagePreview(null);
                setVideoPreview(null);
                setScheduledDate('');
                setScheduleForLater(false);
                setFetchedImages([]);
            }
        } catch (error) {
            console.error('Error scheduling post:', error);
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error scheduling post',
                text: error.response?.data?.message || 'An error occurred while scheduling the post.',
                showConfirmButton: true,
            });
        } finally {
            setIsScheduling(false);
        }
    };

    const handlePublish = async () => {
        // Validate that at least one platform is selected
        if (!selectedPlatforms || selectedPlatforms.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'No Platform Selected',
                text: 'Please select at least one platform to post to.',
                confirmButtonText: 'OK',
                confirmButtonColor: '#2e3192',
                timer: 2000
            });
            return;
        }

        setIsPublishing(true);
        try {
            if (!accessToken || !userId) {
                throw new Error('Access Token or User ID is missing');
            }

            // Check if Instagram is selected and require image
            const isInstagramEnabled = selectedPlatforms.includes('instagram');
            const hasImage = !!(image || selectedImageUrl);
            
            if (isInstagramEnabled && !hasImage) {
                await Swal.fire({
                    icon: 'error',
                    title: 'Image Required for Instagram',
                    html: `
                        <div style="text-align: left;">
                            <p style="margin-bottom: 15px;"><strong>Instagram requires an image to post.</strong></p>
                            <p style="margin-bottom: 20px; color: #666;">Please add an image to your post before publishing to Instagram.</p>
                        </div>
                    `,
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#2e3192',
                });
                setIsPublishing(false);
                return;
            }

            // Validate Instagram image aspect ratio if Instagram is enabled and image exists
            if (isInstagramEnabled && hasImage) {
                try {
                    let validationResult;
                    
                    if (image) {
                        // Validate uploaded file
                        validationResult = await validateInstagramImageFile(image);
                    } else if (selectedImageUrl) {
                        // Validate selected image URL
                        validationResult = await validateInstagramImageUrl(selectedImageUrl);
                    }
                    
                    if (validationResult && !validationResult.isValid) {
                        await Swal.fire({
                            icon: 'error',
                            title: 'Invalid Image Aspect Ratio for Instagram',
                            html: `
                                <div style="text-align: left;">
                                    <p style="margin-bottom: 15px;"><strong>${validationResult.error || 'Image does not meet Instagram requirements.'}</strong></p>
                                    <p style="margin-bottom: 20px; color: #666;">Instagram requires images with aspect ratios between 0.8:1 and 1.91:1 (approximately 4:5 portrait to 1.91:1 landscape).</p>
                                    <p style="color: #666;">Please select a different image with a valid aspect ratio.</p>
                                </div>
                            `,
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#2e3192',
                        });
                        setIsPublishing(false);
                        return;
                    }
                } catch (validationError) {
                    console.error('Error validating Instagram image:', validationError);
                    // If validation fails due to technical issues, warn but allow to proceed
                    // (backend will catch it anyway)
                    const result = await Swal.fire({
                        icon: 'warning',
                        title: 'Image Validation Warning',
                        text: 'Unable to validate image aspect ratio. The post will be attempted, but Instagram may reject it if the aspect ratio is invalid.',
                        confirmButtonText: 'Continue',
                        confirmButtonColor: '#2e3192',
                        showCancelButton: true,
                        cancelButtonText: 'Cancel',
                        cancelButtonColor: '#6c757d',
                    });
                    
                    if (!result.isConfirmed) {
                        setIsPublishing(false);
                        return;
                    }
                }
            }

        const accessCheck = await checkFeatureAccess(FEATURE_NAMES.KNACK_MOMENTS);
        if (!accessCheck.canProceed) {
                const msg = `You have reached your limit for Knack Moments. ${accessCheck.error || 'Please upgrade to continue.'}`;
                Swal.fire({
                    icon: 'warning',
                    title: 'Limit Exceeded',
                    text: msg,
                    confirmButtonText: 'OK',
                });
                setIsPublishing(false);
            return;
        }
    
            let contentToUse = aiGeneratedContent;

            const plainTextContent = contentToUse
                ? toUnicodeBold(contentToUse)
                    .replace(/<\/?br\s*\/?>/g, '\n')
                    .replace(/<\/?p>/g, '\n')
                    .replace(/<\/?[^>]+(>|$)/g, '')
                : '';

            let imageAsset = null;
            let imageUrlToSave = null; // Azure URL or external URL to persist in DB

            if (image) {
                let imageToUpload = image;

                // ✅ Resize image to 1080x1080 (1:1) for Instagram BEFORE uploading
                if (isInstagramEnabled && image.type.startsWith('image/')) {
                    try {
                        console.log('📐 Resizing image to 1080x1080 (1:1) for Instagram...');
                        const resizedBlob = await resizeForInstagram(image);
                        
                        // Validate the resized blob
                        if (!resizedBlob || resizedBlob.size === 0) {
                            throw new Error('Resized image is empty or invalid');
                        }
                        
                        console.log('✅ Resized blob size:', resizedBlob.size, 'bytes');
                        imageToUpload = blobToFile(resizedBlob, `instagram-${Date.now()}.jpg`);
                        
                        // Validate the file
                        if (!imageToUpload || imageToUpload.size === 0) {
                            throw new Error('Failed to convert resized blob to file');
                        }
                        
                        console.log('✅ Image resized successfully for Instagram (1080x1080), file size:', imageToUpload.size);
                    } catch (resizeError) {
                        console.error('❌ Error resizing image for Instagram:', resizeError);
                        await Swal.fire({
                            icon: 'error',
                            title: 'Image Resize Failed',
                            html: `
                                <div style="text-align: left;">
                                    <p style="margin-bottom: 10px;"><strong>Failed to resize image for Instagram:</strong></p>
                                    <p style="margin-bottom: 10px; color: #666;">${resizeError.message || 'The image may be corrupted or invalid.'}</p>
                                    <p style="margin-bottom: 10px; color: #666;">Please try:</p>
                                    <ol style="margin-left: 20px; padding-left: 10px; color: #666;">
                                        <li>Selecting a different image</li>
                                        <li>Or uploading an image from your device</li>
                                    </ol>
                                </div>
                            `,
                            showConfirmButton: true,
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#2e3192'
                        });
                        setIsPublishing(false);
                        return;
                    }
                }

                const formData = new FormData();
                formData.append('file', imageToUpload); // Use resized image if Instagram is enabled
                formData.append('accessToken', accessToken);
                formData.append('userId', userId);
                formData.append('accountype', AccountType);

                if (image.type.startsWith('image/')) {
                    try {
                        // Validate the file before uploading
                        if (!imageToUpload || imageToUpload.size === 0) {
                            throw new Error('Invalid image file. The resized image is empty or corrupted.');
                        }
                        
                        console.log('📤 File ready for upload:', {
                            name: imageToUpload.name,
                            size: imageToUpload.size,
                            type: imageToUpload.type
                        });

                        console.log('📤 Uploading image to LinkedIn...');
                        const imageUploadResponse = await axios.post(
                            `${process.env.REACT_APP_API_BASE_URL}/api/linkedin/upload-image`,
                            formData,
                            {
                                headers: {
                                    'Authorization': `Bearer ${accessToken}`,
                                    'Content-Type': 'multipart/form-data',
                                },
                            }
                        );
                        imageAsset = imageUploadResponse.data.asset;
                        console.log('✅ LinkedIn upload successful, imageAsset:', imageAsset);

                        // Also upload to Azure Blob to persist URL for Published Posts display
                        try {
                            const blobForm = new FormData();
                            blobForm.append('file', imageToUpload); // Use resized image
                            blobForm.append('userId', userId);
                            const blobResp = await axios.post(
                                `${process.env.REACT_APP_API_BASE_URL}/api/upload-image-blob`,
                                blobForm,
                                { headers: { 'Content-Type': 'multipart/form-data' } }
                            );
                            imageUrlToSave = blobResp.data.imageUrl || null;
                        } catch (blobErr) {
                            console.error('Error uploading image to Azure Blob:', blobErr);
                            // Continue even if blob upload fails
                        }
                    } catch (error) {
                        console.error('❌ Error uploading image to LinkedIn:', error);
                        console.error('❌ Error details:', {
                            message: error.message,
                            response: error.response?.data,
                            status: error.response?.status
                        });
                        
                        // Provide more specific error message
                        let errorMessage = 'Image upload failed.';
                        let errorDetails = '';
                        
                        if (error.message?.includes('resize')) {
                            errorMessage = 'Failed to resize image for Instagram.';
                            errorDetails = 'The image could not be resized to the required format.';
                        } else if (error.response?.status === 413) {
                            errorMessage = 'Image file too large.';
                            errorDetails = 'The image file exceeds the maximum size limit.';
                        } else if (error.response?.status === 400) {
                            errorMessage = 'Invalid image format.';
                            errorDetails = 'The image format is not supported or the file is corrupted.';
                        } else if (error.response?.data?.message) {
                            errorMessage = error.response.data.message;
                            errorDetails = error.message || 'Please try again or use a different image.';
                        } else {
                            errorDetails = error.message || 'An unexpected error occurred.';
                        }
                        
                        await Swal.fire({
                            icon: 'error',
                            title: 'Image Upload Failed',
                            html: `
                                <div style="text-align: left;">
                                    <p style="margin-bottom: 10px;"><strong>${errorMessage}</strong></p>
                                    ${errorDetails ? `<p style="margin-bottom: 15px; color: #666;">${errorDetails}</p>` : ''}
                                    <p style="margin-bottom: 10px; color: #666;"><strong>Please try the following:</strong></p>
                                    <ol style="margin-left: 20px; padding-left: 10px; color: #666;">
                                        <li>Select a different image</li>
                                        <li>Or try again in a few moments</li>
                                    </ol>
                                </div>
                            `,
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#2e3192',
                            width: '500px'
                        });
                        setIsPublishing(false);
                        return;
                    }
                }
            } else if (selectedImageUrl) {
                try {
                    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/download-image?url=${encodeURIComponent(selectedImageUrl)}`);
                    if (!response.ok) {
                        throw new Error('Failed to download image');
                    }
                    const blob = await response.blob();
                    const fileName = `image_${Date.now()}.jpg`;
                    let file = new File([blob], fileName, { type: blob.type });

                    // ✅ Resize image to 1080x1080 (1:1) for Instagram BEFORE uploading
                    if (isInstagramEnabled) {
                        try {
                            console.log('📐 Resizing selected image to 1080x1080 (1:1) for Instagram...');
                            const resizedBlob = await resizeForInstagram(selectedImageUrl);
                            
                            // Validate the resized blob
                            if (!resizedBlob || resizedBlob.size === 0) {
                                throw new Error('Resized image is empty or invalid');
                            }
                            
                            console.log('✅ Resized blob size:', resizedBlob.size, 'bytes');
                            file = blobToFile(resizedBlob, `instagram-${Date.now()}.jpg`);
                            
                            // Validate the file
                            if (!file || file.size === 0) {
                                throw new Error('Failed to convert resized blob to file');
                            }
                            
                            console.log('✅ Selected image resized successfully for Instagram (1080x1080), file size:', file.size);
                        } catch (resizeError) {
                            console.error('❌ Error resizing selected image for Instagram:', resizeError);
                            // Try one more time with the downloaded blob directly
                            try {
                                console.log('🔄 Retrying resize with downloaded blob...');
                                const resizedBlob = await resizeForInstagram(file);
                                
                                // Validate the resized blob
                                if (!resizedBlob || resizedBlob.size === 0) {
                                    throw new Error('Resized image is empty or invalid on retry');
                                }
                                
                                file = blobToFile(resizedBlob, `instagram-${Date.now()}.jpg`);
                                
                                // Validate the file
                                if (!file || file.size === 0) {
                                    throw new Error('Failed to convert resized blob to file on retry');
                                }
                                
                                console.log('✅ Image resized successfully on retry, file size:', file.size);
                            } catch (retryError) {
                                console.error('❌ Retry also failed:', retryError);
                                await Swal.fire({
                                    icon: 'error',
                                    title: 'Image Resize Failed',
                                    html: `
                                        <div style="text-align: left;">
                                            <p style="margin-bottom: 10px;"><strong>Failed to resize image for Instagram:</strong></p>
                                            <p style="margin-bottom: 10px; color: #666;">${resizeError.message || retryError.message || 'The image may be corrupted or invalid.'}</p>
                                            <p style="margin-bottom: 10px; color: #666;">Please try:</p>
                                            <ol style="margin-left: 20px; padding-left: 10px; color: #666;">
                                                <li>Selecting a different image</li>
                                                <li>Or uploading an image from your device</li>
                                            </ol>
                                        </div>
                                    `,
                                    showConfirmButton: true,
                                    confirmButtonText: 'OK',
                                    confirmButtonColor: '#2e3192'
                                });
                                setIsPublishing(false);
                                return;
                            }
                        }
                    }

                    // Validate the file before uploading
                    if (!file || file.size === 0) {
                        throw new Error('Invalid image file. The resized image is empty or corrupted.');
                    }
                    
                    console.log('📤 File ready for upload:', {
                        name: file.name,
                        size: file.size,
                        type: file.type
                    });

                    const formData = new FormData();
                    formData.append('file', file); // Use resized file if Instagram is enabled
                    formData.append('accessToken', accessToken);
                    formData.append('userId', userId);
                    formData.append('accountype', AccountType);

                    console.log('📤 Uploading image to LinkedIn...');
                    const imageUploadResponse = await axios.post(
                        `${process.env.REACT_APP_API_BASE_URL}/api/linkedin/upload-image`,
                        formData,
                        {
                            headers: {
                                'Authorization': `Bearer ${accessToken}`,
                                'Content-Type': 'multipart/form-data',
                            },
                        }
                    );
                    imageAsset = imageUploadResponse.data.asset;
                    console.log('✅ LinkedIn upload successful, imageAsset:', imageAsset);

                    // For external selected image, upload resized version to Azure and save Azure URL
                    try {
                        const blobForm = new FormData();
                        blobForm.append('file', file); // Use resized file
                        blobForm.append('userId', userId);
                        const blobResp = await axios.post(
                            `${process.env.REACT_APP_API_BASE_URL}/api/upload-image-blob`,
                            blobForm,
                            { headers: { 'Content-Type': 'multipart/form-data' } }
                        );
                        imageUrlToSave = blobResp.data.imageUrl || selectedImageUrl;
                    } catch (blobErr) {
                        console.error('Error uploading resized image to Azure Blob:', blobErr);
                        // Fallback to original URL if blob upload fails
                        imageUrlToSave = selectedImageUrl;
                    }
                } catch (error) {
                    console.error('❌ Error downloading and uploading image:', error);
                    console.error('❌ Error details:', {
                        message: error.message,
                        response: error.response?.data,
                        status: error.response?.status
                    });
                    
                    // Provide more specific error message
                    let errorMessage = 'Image upload failed.';
                    let errorDetails = '';
                    
                    if (error.message?.includes('resize')) {
                        errorMessage = 'Failed to resize image for Instagram.';
                        errorDetails = 'The image could not be resized to the required format.';
                    } else if (error.message?.includes('download')) {
                        errorMessage = 'Failed to download image.';
                        errorDetails = 'Could not download the image from the server.';
                    } else if (error.response?.status === 413) {
                        errorMessage = 'Image file too large.';
                        errorDetails = 'The image file exceeds the maximum size limit.';
                    } else if (error.response?.status === 400) {
                        errorMessage = 'Invalid image format.';
                        errorDetails = 'The image format is not supported or the file is corrupted.';
                    } else if (error.response?.data?.message) {
                        errorMessage = error.response.data.message;
                        errorDetails = error.message || 'Please try again or use a different image.';
                    } else {
                        errorDetails = error.message || 'An unexpected error occurred.';
                    }
                    
                    await Swal.fire({
                        icon: 'error',
                        title: 'Image Upload Failed',
                        html: `
                            <div style="text-align: left;">
                                <p style="margin-bottom: 10px;"><strong>${errorMessage}</strong></p>
                                ${errorDetails ? `<p style="margin-bottom: 15px; color: #666;">${errorDetails}</p>` : ''}
                                <p style="margin-bottom: 10px; color: #666;"><strong>Please try the following:</strong></p>
                                <ol style="margin-left: 20px; padding-left: 10px; color: #666;">
                                    <li>Select a different image</li>
                                    <li>Or try again in a few moments</li>
                                </ol>
                            </div>
                        `,
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#2e3192',
                        width: '500px'
                    });
                    setIsPublishing(false);
                    return;
                }
            }

            // Handle video upload if image is a video file
            let videoAsset = null;
            let videoUrlToSave = null;
            if (image && image.type && image.type.startsWith('video/')) {
                try {
                    const formData = new FormData();
                    formData.append('file', image);
                    formData.append('accessToken', accessToken);
                    formData.append('userId', userId);
                    formData.append('accountype', AccountType);

                    // Upload video to LinkedIn
                    const videoUploadResponse = await axios.post(
                        `${process.env.REACT_APP_API_BASE_URL}/api/linkedin/upload-video`,
                        formData,
                        {
                            headers: {
                                'Authorization': `Bearer ${accessToken}`,
                                'Content-Type': 'multipart/form-data',
                            },
                        }
                    );
                    videoAsset = videoUploadResponse.data.asset;

                    // Also upload to Azure Blob to get URL for database saving
                    try {
                        const blobForm = new FormData();
                        blobForm.append('file', image);
                        blobForm.append('userId', userId);
                        const blobResp = await axios.post(
                            `${process.env.REACT_APP_API_BASE_URL}/api/upload-image-blob`,
                            blobForm,
                            { headers: { 'Content-Type': 'multipart/form-data' } }
                        );
                        videoUrlToSave = blobResp.data.imageUrl || null;
                    } catch (blobErr) {
                        console.error('Error uploading video to Azure Blob:', blobErr);
                        // Continue even if blob upload fails
                    }
                } catch (error) {
                    console.error('Error uploading video:', error);
                    await Swal.fire({
                        icon: 'error',
                        title: 'Video Upload Failed',
                        html: `
                            <div style="text-align: left;">
                                <p><strong>Video upload failed. Please try the following:</strong></p>
                                <ol style="margin-left: 20px; padding-left: 10px;">
                                    <li>Download the video to your local Downloads folder</li>
                                    <li>Remove the video from the media section</li>
                                    <li>Re-upload the video from your local Downloads folder</li>
                                </ol>
                            </div>
                        `,
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#2e3192'
                    });
                    setIsPublishing(false);
                    return;
                }
            }

             // Use selected platforms directly
             const platformsToPublish = selectedPlatforms;

             const resp = await axios.post(
                 `${process.env.REACT_APP_API_BASE_URL}/api/linkedin/post-content`,
                 {
                     accessToken,
                     userId,
                     text: plainTextContent, // Use 'text' field like CreatePostPage
                     imageAsset: image && image.type && image.type.startsWith('video/') ? null : imageAsset,
                     videoAsset: videoAsset,
                     accountype: AccountType,
                     postType: 'knack_moment', // hint backend to mark PromptType = 2
                     // Save holiday name as prompt (or customPrompt if no holiday selected)
                     prompt: selectedHoliday || customPrompt || null,
                     imageUrl: videoUrlToSave || imageUrlToSave || null, // Save video URL in Image field for compatibility
                     videoUrl: videoUrlToSave || null, // Also save in Video field if backend supports it
                     platforms: platformsToPublish // Send selected platforms array
                 },
                 {
                     headers: {
                         'Authorization': `Bearer ${accessToken}`,
                         'Content-Type': 'application/json',
                     },
                 }
             );

            if (resp.status === 200) {
                try {
                    await logFeatureUsage(FEATURE_NAMES.KNACK_MOMENTS, 1, JSON.stringify({
                        hasImage: !!(image || selectedImageUrl),
                    }));
                } catch (usageError) {
                    console.error('Error logging feature usage:', usageError);
                }

                // Build success message based on selected platforms
                const selectedPlatformNames = platformsToPublish.map(code => {
                    const platform = enabledPlatforms.find(p => p.code === code);
                    return platform ? platform.name : code;
                });
                const successMessage = selectedPlatformNames.length === 1
                    ? `Posted successfully to ${selectedPlatformNames[0]}`
                    : selectedPlatformNames.length === 2
                    ? `Posted successfully to ${selectedPlatformNames[0]} and ${selectedPlatformNames[1]}`
                    : `Posted successfully to ${selectedPlatformNames.slice(0, -1).join(', ')}, and ${selectedPlatformNames[selectedPlatformNames.length - 1]}`;
                
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: successMessage,
                    showConfirmButton: false,
                    timer: 3000,
                });

                // Reset form
                setCustomPrompt('');
                setAiGeneratedContent('');
                setSelectedImageUrl(null);
                setImage(null);
                setImagePreview(null);
                setVideoPreview(null);
                setFetchedImages([]);
            }
        } catch (error) {
            console.error('Error publishing post:', error);
            const errorMessage = enabledPlatforms.length > 0 
                ? `Error posting to ${enabledPlatforms.map(p => p.name).join(' & ')}`
                : 'Error posting';
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: errorMessage,
                text: error.response?.data?.message || 'An error occurred while posting.',
                showConfirmButton: true,
            });
        } finally {
            setIsPublishing(false);
        }
    };

    return (
        <div style={{ 
            background: '#f3f2ef',
            minHeight: '100vh',
            padding: '0'
        }}>
            <SideNavbar>
                <div className="card shadow-sm p-4 mt-3" style={{ border: 'none', backgroundColor: '#fff', borderRadius: '12px' }}>
                    {/* Header matching CreatePostPage */}
                    <div className="create-post-header" style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginBottom: '24px',
                        paddingBottom: '16px',
                        borderBottom: '1px solid #e0dfdc',
                        flexWrap: 'wrap',
                        gap: '16px'
                    }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            flex: '1 1 auto',
                            minWidth: '200px'
                        }}>
                            <div style={{
                                width: '48px',
                                height: '48px',
                                borderRadius: '50%',
                                backgroundColor: '#2e3192',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginRight: '12px',
                                flexShrink: 0
                            }}>
                                <FontAwesomeIcon icon={faEdit} style={{ color: 'white', fontSize: '18px' }} />
                            </div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <h2 style={{ 
                                    color: '#000000',
                                    fontWeight: '600',
                                    fontSize: '20px',
                                    margin: '0 0 4px 0'
                                }}>
                                    Knack Moments
                                </h2>
                                <p style={{ color: '#666666', margin: '0', fontSize: '14px' }}>
                                    Create holiday and special occasion posts
                                </p>
                            </div>
                        </div>
                        
                        {/* Navigation Icons */}
                        <div className="create-post-nav-icons" style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                            <button
                                onClick={() => navigate('/viewallpendingposts')}
                                title="View Pending Posts"
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    cursor: 'pointer',
                                    padding: '8px',
                                    borderRadius: '8px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: '4px',
                                    transition: 'background-color 0.2s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = '#f0f0f0';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = 'transparent';
                                }}
                            >
                                <FontAwesomeIcon icon={faExclamationTriangle} style={{ fontSize: '20px', color: '#2e3192' }} />
                                <span style={{ fontSize: '11px', fontWeight: '500', color: '#2e3192' }}>Pending</span>
                            </button>
                            
                            <button
                                onClick={() => navigate('/viewallapprovedposts')}
                                title="View Approved Posts"
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    cursor: 'pointer',
                                    padding: '8px',
                                    borderRadius: '8px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: '4px',
                                    transition: 'background-color 0.2s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = '#f0f0f0';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = 'transparent';
                                }}
                            >
                                <FontAwesomeIcon icon={faChartBar} style={{ fontSize: '20px', color: '#2e3192' }} />
                                <span style={{ fontSize: '11px', fontWeight: '500', color: '#2e3192' }}>Approved</span>
                            </button>
                            
                            <button
                                onClick={() => navigate('/schedule-list')}
                                title="View Schedule List"
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    cursor: 'pointer',
                                    padding: '8px',
                                    borderRadius: '8px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: '4px',
                                    transition: 'background-color 0.2s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = '#f0f0f0';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = 'transparent';
                                }}
                            >
                                <FontAwesomeIcon icon={faLineChart} style={{ fontSize: '20px', color: '#2e3192' }} />
                                <span style={{ fontSize: '11px', fontWeight: '500', color: '#2e3192' }}>Schedule</span>
                            </button>
                            
                            <button
                                onClick={() => navigate('/viewallpostedposts')}
                                title="View Published Posts"
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    cursor: 'pointer',
                                    padding: '8px',
                                    borderRadius: '8px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: '4px',
                                    transition: 'background-color 0.2s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = '#f0f0f0';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = 'transparent';
                                }}
                            >
                                <FontAwesomeIcon icon={faNewspaper} style={{ fontSize: '20px', color: '#2e3192' }} />
                                <span style={{ fontSize: '11px', fontWeight: '500', color: '#2e3192' }}>Published</span>
                            </button>
                                          </div>
                    </div>

                    <div className="card-body" style={{ paddingTop: '0' }}>
                        {/* Prompt Input Section */}
                        <div style={{ marginBottom: '20px' }}>
                                                        <textarea
                                placeholder="What do you want to talk about?"
                                value={customPrompt}
                                onChange={(e) => setCustomPrompt(e.target.value)}
                                                            style={{
                                                                width: '100%',
                                                                border: 'none',
                                    fontSize: '16px',
                                    padding: '16px 0',
                                    background: 'transparent',
                                    resize: 'none',
                                    outline: 'none',
                                    minHeight: '100px',
                                    fontFamily: 'inherit'
                                }}
                            />
                            {/* Toolbar */}
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                paddingTop: '16px',
                                borderTop: '1px solid #e0dfdc'
                            }}>
                                {/* Left side: Lightbulb */}
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                    <button
                                        onClick={() => setShowHolidayModal(true)}
                                        title="Select Holiday"
                                        style={{
                                            background: 'transparent',
                                            border: 'none',
                                            cursor: 'pointer',
                                            padding: '8px',
                                            borderRadius: '4px',
                                            color: '#666666',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.backgroundColor = '#f3f2ef';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.backgroundColor = 'transparent';
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faLightbulb} style={{ fontSize: '20px' }} />
                                </button>
                            </div>

                                {/* Right: Generate Content Button */}
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <button
                                        onClick={generateContent}
                                        disabled={isGenerating || !customPrompt.trim()}
                                        style={{
                                            background: (isGenerating || !customPrompt.trim())
                                                ? '#cccccc'
                                                : '#2e3192',
                                            border: 'none',
                                            borderRadius: '20px',
                                            padding: '8px 16px',
                                            color: 'white',
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            cursor: (isGenerating || !customPrompt.trim()) ? 'not-allowed' : 'pointer',
                                            transition: 'all 0.3s ease'
                                        }}
                                    >
                                        {isGenerating ? (
                                            <>
                                                <FontAwesomeIcon icon={faSpinner} spin style={{ marginRight: '8px' }} />
                                                Crafting...
                                                                </>
                                                            ) : (
                                                                <>
                                                <FontAwesomeIcon icon={faStar} style={{ marginRight: '8px' }} />
                                                Craft
                                            </>
                                        )}
                                        </button>
                                </div>
                            </div>
                                    </div>

                        {/* AI Generated Content Display - Matching CreatePostPage */}
                        {aiGeneratedContent && (
                            <div className="mb-4">
                                <h5 style={{ color: '#2e3192', fontWeight: 'bold', marginBottom: '12px' }}>Smart Content</h5>
                                <textarea
                                    value={aiGeneratedContent}
                                    onChange={(e) => {
                                        const content = e.target.value;
                                        if (content.length > 2950) {
                                                        Swal.fire({
                                                            icon: 'warning',
                                                title: 'Content Length Exceeded',
                                                text: 'The content should not exceed 2950 characters.',
                                                showConfirmButton: true,
                                            });
                                        } else {
                                            setAiGeneratedContent(content);
                                        }
                                    }}
                                    style={{
                                        fontSize: '15px',
                                        borderRadius: '8px',
                                        border: '1px solid #cfeafb',
                                        background: '#FFFFFF',
                                        height: aiGeneratedContent ? '400px' : '100px',
                                        width: '100%',
                                        padding: '15px',
                                        resize: 'vertical'
                                    }}
                                    placeholder="AI-generated post content appears here..."
                                    rows="4"
                                    cols="50"
                                            />
                                        </div>
                        )}

                        {/* AI Media Suggestions */}
                        {aiGeneratedContent && (
                            <div className="mb-4">
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                                    <h5 style={{ 
                                        color: '#1a202c', 
                                        fontWeight: '600', 
                                        marginBottom: '0',
                                        fontSize: '1.1rem'
                                    }}>
                                        AI Media Suggestions
                                    </h5>
                                    <button
                                        onClick={() => {
                                            setImageKeywords('');
                                            fetchImagesWithKeywords(true);
                                        }}
                                        disabled={isRefreshingImages || isCraftingVisual || !aiGeneratedContent?.trim()}
                                                            style={{
                                            background: (isRefreshingImages || isCraftingVisual || !aiGeneratedContent?.trim()) ? '#cccccc' : '#2e3192',
                                                                border: 'none',
                                            borderRadius: '6px',
                                            padding: '6px 12px',
                                            color: 'white',
                                            fontSize: '13px',
                                            fontWeight: '500',
                                            cursor: (isRefreshingImages || isCraftingVisual || !aiGeneratedContent?.trim()) ? 'not-allowed' : 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            if (!isRefreshingImages && !isCraftingVisual && aiGeneratedContent?.trim()) {
                                                e.target.style.backgroundColor = '#1a1d5c';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (!isRefreshingImages && !isCraftingVisual && aiGeneratedContent?.trim()) {
                                                e.target.style.backgroundColor = '#2e3192';
                                            }
                                        }}
                                        title="Refresh images using auto-extracted keywords from your prompt and content"
                                    >
                                        <FontAwesomeIcon 
                                            icon={isRefreshingImages ? faSpinner : faImages} 
                                            style={{ 
                                                fontSize: '12px',
                                                animation: isRefreshingImages ? 'spin 1s linear infinite' : 'none'
                                            }} 
                                        />
                                        {isRefreshingImages ? 'Searching...' : 'Refresh'}
                                    </button>
                                                    </div>
                                
                                {/* Image Keywords Input */}
                                <div className="mb-3">
                                    <label style={{ 
                                        fontSize: '13px', 
                                        fontWeight: '500', 
                                        color: '#2e3192',
                                        marginBottom: '6px',
                                        display: 'block'
                                    }}>
                                        Image Keywords (Optional - comma-separated)
                                    </label>
                                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                        <input
                                            type="text"
                                            value={imageKeywords}
                                            onChange={(e) => setImageKeywords(e.target.value)}
                                            placeholder="e.g., business, technology, AI, innovation"
                                            style={{
                                                flex: 1,
                                                fontSize: '14px',
                                                borderRadius: '6px',
                                                border: '1px solid #cfeafb',
                                                background: '#FFFFFF',
                                                padding: '8px 12px',
                                                outline: 'none'
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' && imageKeywords.trim()) {
                                                    fetchImagesWithKeywords(false);
                                                }
                                            }}
                                        />
                                                                    <button
                                            onClick={() => fetchImagesWithKeywords(false)}
                                            disabled={isCraftingVisual || isRefreshingImages || !imageKeywords?.trim()}
                                            style={{
                                                background: (isCraftingVisual || isRefreshingImages || !imageKeywords?.trim()) ? '#cccccc' : '#2e3192',
                                                border: 'none',
                                                borderRadius: '6px',
                                                padding: '8px 16px',
                                                color: 'white',
                                                fontSize: '13px',
                                                fontWeight: '500',
                                                cursor: (isCraftingVisual || isRefreshingImages || !imageKeywords?.trim()) ? 'not-allowed' : 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                transition: 'all 0.3s ease',
                                                whiteSpace: 'nowrap'
                                            }}
                                            onMouseEnter={(e) => {
                                                if (!isCraftingVisual && !isRefreshingImages && imageKeywords?.trim()) {
                                                    e.target.style.backgroundColor = '#1a1d5c';
                                                }
                                            }}
                                            onMouseLeave={(e) => {
                                                if (!isCraftingVisual && !isRefreshingImages && imageKeywords?.trim()) {
                                                    e.target.style.backgroundColor = '#2e3192';
                                                }
                                            }}
                                            title="Generate images using your keywords"
                                        >
                                            <FontAwesomeIcon 
                                                icon={isCraftingVisual ? faSpinner : faImage} 
                                                style={{ 
                                                    fontSize: '12px',
                                                    animation: isCraftingVisual ? 'spin 1s linear infinite' : 'none'
                                                }} 
                                            />
                                            {isCraftingVisual ? 'Crafting...' : 'Craft Visual'}
                                                                    </button>
                                    </div>
                                    <p style={{ 
                                        fontSize: '11px', 
                                        color: '#6c757d', 
                                        marginTop: '4px',
                                        marginBottom: '0'
                                    }}>
                                        Enter keywords and click "Craft Visual" to generate images, or leave empty and use "Refresh" for auto-extraction
                                    </p>
                                </div>
                                
                                {(isFetchingImages || isRefreshingImages || isCraftingVisual) ? (
                                    <div className="text-center p-4">
                                        <FontAwesomeIcon icon={faSpinner} spin style={{ fontSize: '2rem', color: '#2e3192' }} />
                                        <p className="mt-2">Fetching images...</p>
                                    </div>
                                ) : fetchedImages.length > 0 ? (
                                    <div className="row" style={{ gap: '4px' }}>
                                        {fetchedImages.map((img, index) => (
                                            <div key={index} className="col-4 col-md-3 col-lg-2 col-xl-2">
                                                <div
                                                    className="position-relative"
                                                    style={{
                                                        aspectRatio: "1",
                                                        borderRadius: "6px",
                                                        overflow: "hidden",
                                                        cursor: "pointer",
                                                        border: selectedImageUrl === img ? "2px solid #2e3192" : "1px solid transparent",
                                                        transition: "all 0.2s ease",
                                                        backgroundColor: "#f7fafc",
                                                        maxWidth: "120px"
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        if (selectedImageUrl !== img) {
                                                            e.currentTarget.style.borderColor = "#cbd5e0";
                                                        }
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        if (selectedImageUrl !== img) {
                                                            e.currentTarget.style.borderColor = "transparent";
                                                        }
                                                    }}
                                                    onClick={() => handleSelectSuggestedImage(img)}
                                                >
                                                    <img
                                                        src={img}
                                                        alt="Suggested"
                                                        style={{
                                                            width: "100%",
                                                            height: "100%",
                                                            objectFit: "cover",
                                                            display: "block"
                                                        }}
                                                    />

                                                    {/* Top-right checkbox */}
                                                    <div
                                                        className="position-absolute"
                                                            style={{
                                                            top: "6px",
                                                            right: "6px",
                                                            width: "22px",
                                                            height: "22px",
                                                            borderRadius: "50%",
                                                            backgroundColor: selectedImagename === img ? "#2e3192" : "rgba(255, 255, 255, 0.95)",
                                                            border: selectedImagename === img ? "none" : "2px solid rgba(0, 0, 0, 0.2)",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            cursor: "pointer",
                                                            transition: "all 0.15s ease",
                                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.15)"
                                                        }}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            const newChecked = !(selectedImagename === img);
                                                            setSelectedImagename(newChecked ? img : null);
                                                            setSelectedImageUrl(newChecked ? img : null);
                                                            if (newChecked) {
                                                                setImage(null);
                                                                setImagePreview(null);
                                                                setVideoPreview(null);
                                                            }
                                                        }}
                                                    >
                                                        {selectedImagename === img && (
                                                            <FontAwesomeIcon
                                                                icon={faCheck}
                                                                style={{
                                                                    color: "#fff",
                                                                    fontSize: "10px"
                                                                }}
                                                            />
                                                        )}
                                                    </div>

                                                    {/* Bottom action buttons overlay */}
                                                    <div
                                                        className="position-absolute d-flex gap-2"
                                                        style={{
                                                            bottom: "8px",
                                                            left: "50%",
                                                            transform: "translateX(-50%)",
                                                            opacity: selectedImageUrl === img ? "1" : "0",
                                                            transition: "opacity 0.2s ease"
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.opacity = "1";
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            if (selectedImageUrl !== img) {
                                                                e.currentTarget.style.opacity = "0";
                                                            }
                                                        }}
                                                    >
                                                                    <button
                                                            className="btn btn-sm"
                                                            style={{
                                                                minWidth: "32px",
                                                                height: "32px",
                                                                padding: "0",
                                                                borderRadius: "6px",
                                                                backgroundColor: "rgba(255, 255, 255, 0.95)",
                                                                border: "none",
                                                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center"
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setSelectedImageUrl(img);
                                                                setIsImageModalOpen(true);
                                                            }}
                                                            title="View Full Image"
                                                        >
                                                            <FontAwesomeIcon icon={faImage} style={{ color: "#2e3192", fontSize: "12px" }} />
                                                                    </button>

                                                                    <button
                                                            className="btn btn-sm"
                                                            style={{
                                                                minWidth: "32px",
                                                                height: "32px",
                                                                padding: "0",
                                                                borderRadius: "6px",
                                                                backgroundColor: "rgba(255, 255, 255, 0.95)",
                                                                border: "none",
                                                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                                                                display: "none",
                                                                alignItems: "center",
                                                                justifyContent: "center"
                                                            }}
                                                            onClick={(e) => handleDownloadImage(img, e)}
                                                            title="Download Image"
                                                        >
                                                            <FontAwesomeIcon icon={faDownload} style={{ color: "#2e3192", fontSize: "12px" }} />
                                                                    </button>

                                                                    <button
                                                            className="btn btn-sm"
                                                            style={{
                                                                minWidth: "32px",
                                                                height: "32px",
                                                                padding: "0",
                                                                borderRadius: "6px",
                                                                backgroundColor: "#2e3192",
                                                                border: "none",
                                                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                                                                display: "none",
                                                                alignItems: "center",
                                                                justifyContent: "center"
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setSelectedImagename(img);
                                                                setSelectedImageUrl(img);
                                                                setImage(null);
                                                                setImagePreview(null);
                                                                setVideoPreview(null);
                                                                setFileInputKey(prev => prev + 1);
                                                            }}
                                                            title="Select This Image"
                                                        >
                                                            <FontAwesomeIcon icon={faCheck} style={{ color: "#fff", fontSize: "12px" }} />
                                                                    </button>
                                                    </div>

                                                    {/* Hover overlay */}
                                                    {selectedImageUrl !== img && (
                                                        <div
                                                            className="position-absolute"
                                                            style={{
                                                                top: 0,
                                                                left: 0,
                                                                right: 0,
                                                                bottom: 0,
                                                                backgroundColor: "rgba(0, 0, 0, 0)",
                                                                transition: "background-color 0.2s ease",
                                                                pointerEvents: "none"
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.05)";
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0)";
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : aiGeneratedContent ? (
                                    <div className="text-center p-4" style={{
                                        border: '1px dashed #dee2e6',
                                        borderRadius: '8px',
                                        backgroundColor: '#f8f9fa',
                                        color: '#6c757d'
                                    }}>
                                        <FontAwesomeIcon icon={faImage} style={{ fontSize: '2rem', color: '#adb5bd', marginBottom: '10px' }} />
                                        <p className="mb-0 small">
                                            No images found for this content. Try adding hashtags to your prompt.
                                        </p>
                                </div>
                                ) : null}
                            </div>
                        )}

                        {/* Upload Image/Video Section */}
                        {aiGeneratedContent && (
                            <div className="mb-4">
                                <div className="form-group">
                                    <input
                                        key={fileInputKey}
                                        ref={fileInputRef}
                                        type="file"
                                        onChange={(e) => {
                                            handleImageChange(e);
                                            setSelectedImageUrl(null);
                                        }}
                                        className="form-control"
                                        accept="image/*,video/*"
                                        style={{
                                            fontSize: '15px',
                                            borderRadius: '8px',
                                            border: '1px solid #cfeafb',
                                            background: '#FFFFFF',
                                            padding: '10px',
                                            display: 'none'
                                        }}
                                    />
                                                                    <button
                                                                        type="button"
                                        className="btn"
                                        onClick={() => fileInputRef.current?.click()}
                                        title="Upload Image or Video"
                                        style={{
                                            fontSize: '16px',
                                            borderRadius: '25px',
                                            border: 'none',
                                            background: '#2e3192',
                                            padding: '12px',
                                            color: 'white',
                                            fontWeight: 'bold',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: 'auto'
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faUpload} />
                                                                    </button>
                                    {(image || selectedImageUrl) && (
                                        <div className="mt-2">
                                            {image ? (
                                                <div>
                                                    <p className="mb-0" style={{ color: '#2e3192', fontWeight: 'bold' }}>
                                                        Selected: {(image.type && image.type.startsWith('video/')) ? 'Uploaded Video' : 'Uploaded Image'}
                                                    </p>
                                                    {imagePreview && (
                                                        <div className="mt-2">
                                                            <img
                                                                src={imagePreview}
                                                                alt="Uploaded"
                                                                style={{
                                                                    width: "150px",
                                                                    height: "150px",
                                                                    objectFit: "cover",
                                                                    borderRadius: "8px",
                                                                    border: "2px solid #2e3192"
                                                                }}
                                                            />
                                                        </div>
                                                    )}
                                                    {videoPreview && (
                                                        <div className="mt-2">
                                                            <video
                                                                src={videoPreview}
                                                                controls
                                                                style={{
                                                                    width: "200px",
                                                                    maxHeight: "200px",
                                                                    borderRadius: "8px",
                                                                    border: "2px solid #2e3192"
                                                                }}
                                                            >
                                                                Your browser does not support the video tag.
                                                            </video>
                                                        </div>
                                                    )}
                                                </div>
                                            ) : selectedImageUrl ? (
                                                <div>
                                                    <p className="mb-0" style={{ color: '#2e3192', fontWeight: 'bold' }}>
                                                        Selected: AI Suggested Image
                                                    </p>
                                                    <div className="mt-2">
                                                        <img
                                                            src={selectedImageUrl}
                                                            alt="Selected"
                                                            style={{
                                                                width: "150px",
                                                                height: "150px",
                                                                objectFit: "cover",
                                                                borderRadius: "8px",
                                                                border: "2px solid #2e3192"
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            ) : null}
                                        </div>
                                    )}
                                    </div>
                                </div>
                        )}

                        {/* Schedule Options */}
                        {aiGeneratedContent && (
                            <div className="mb-4">
                                <div className="d-flex align-items-center gap-4">
                                    <div className="form-check form-switch">
                                    <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="scheduleToggle"
                                            checked={scheduleForLater}
                                            onChange={(e) => setScheduleForLater(e.target.checked)}
                                            style={{
                                                transform: 'scale(1.2)',
                                                cursor: 'pointer'
                                            }}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="scheduleToggle"
                                            style={{
                                                fontWeight: 'bold',
                                                cursor: 'pointer',
                                                color: scheduleForLater ? '#2e3192' : '#6c757d'
                                            }}
                                        >
                                            Schedule for Later
                                        </label>
                        </div>
                                </div>
                               
                                {scheduleForLater && (
                                    <div className="mt-3">
                        <div className="row">
                                            <div className="col-md-6">
                                                <label className="form-label">Schedule Date & Time</label>
                                    <input
                                                    type="datetime-local"
                                                    className="form-control"
                                                    value={scheduledDate}
                                                    onChange={(e) => setScheduledDate(e.target.value)}
                                                    min={getCurrentLocalDateTime()}
                                                    max={getMaxLocalDateTime()}
                                                    style={{ borderRadius: '8px', border: '1px solid #cfeafb' }}
                                    />
                                </div>
                                            <div className="col-md-6">
                                                <label className="form-label">Timezone</label>
                                                <div style={{ borderRadius: '8px', border: '1px solid #cfeafb' }}>
                                                    <TimezoneSelect
                                                        value={timezone}
                                                        onChange={setTimezone}
                                                        placeholder="Select timezone"
                                    />
                            </div>
                          </div>
                            </div>
                                </div>
                                )}
                            </div>
                        )}

                        {/* Platform Selection - Only show for Page accounts */}
                        {aiGeneratedContent && !platformsLoading && enabledPlatforms.length > 0 && (AccountType !== 'User' && AccountType !== 'user') && (
                            <div style={{
                                marginTop: '20px',
                                padding: '16px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '8px',
                                border: '1px solid #e0dfdc'
                            }}>
                                <label style={{
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    color: '#2e3192',
                                    marginBottom: '12px',
                                    display: 'block'
                                }}>
                                    Select Platforms to Post To:
                                </label>
                                <div style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: '16px',
                                    alignItems: 'center'
                                }}>
                                    {enabledPlatforms.map((platform) => {
                                        const platformIcons = {
                                            linkedin: <FaLinkedin style={{ color: '#0077b5', fontSize: '24px' }} />,
                                            facebook: <FaFacebook style={{ color: '#1877F2', fontSize: '24px' }} />,
                                            instagram: <FaInstagram style={{ color: '#E4405F', fontSize: '24px' }} />
                                        };
                                        const isSelected = selectedPlatforms.includes(platform.code);
                                        
                                        return (
                                            <label
                                                key={platform.code}
                                                title={platform.name}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    cursor: 'pointer',
                                                    padding: '10px',
                                                    borderRadius: '8px',
                                                    backgroundColor: isSelected ? '#e8f0fe' : 'white',
                                                    border: `2px solid ${isSelected ? '#2e3192' : '#e0dfdc'}`,
                                                    transition: 'all 0.2s ease',
                                                    userSelect: 'none',
                                                    minWidth: '48px',
                                                    height: '48px',
                                                    position: 'relative'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor = isSelected ? '#d0e7ff' : '#f0f0f0';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor = isSelected ? '#e8f0fe' : 'white';
                                                }}
                                            >
                                                <input
                                                    type="checkbox"
                                                    checked={isSelected}
                                                    onChange={() => handlePlatformToggle(platform.code)}
                                                    style={{
                                                        position: 'absolute',
                                                        top: '4px',
                                                        right: '4px',
                                                        width: '16px',
                                                        height: '16px',
                                                        cursor: 'pointer',
                                                        accentColor: '#2e3192',
                                                        zIndex: 1
                                                    }}
                                                />
                                                <span style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}>
                                                    {platformIcons[platform.code] || <FaLinkedin style={{ fontSize: '24px' }} />}
                                                </span>
                                            </label>
                                        );
                                    })}
                                </div>
                                <small style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginTop: '8px',
                                    color: '#666',
                                    fontSize: '12px',
                                    gap: '8px'
                                }}>
                                    Selected: {selectedPlatforms.length > 0 
                                        ? selectedPlatforms.map((code, index) => {
                                            const platformIcons = {
                                                linkedin: <FaLinkedin key={index} style={{ color: '#0077b5', fontSize: '16px' }} />,
                                                facebook: <FaFacebook key={index} style={{ color: '#1877F2', fontSize: '16px' }} />,
                                                instagram: <FaInstagram key={index} style={{ color: '#E4405F', fontSize: '16px' }} />
                                            };
                                            return platformIcons[code] || null;
                                        })
                                        : 'None'}
                                </small>
                            </div>
                        )}

                        {/* Action Buttons */}
                        {aiGeneratedContent && (
                            <div style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                alignItems: 'center',
                                paddingTop: '16px',
                                borderTop: '1px solid #e0dfdc'
                            }}>
                                <div style={{ display: 'flex', gap: '12px' }}>
                                    <button
                                        onClick={handlePublish}
                                        disabled={!aiGeneratedContent.trim() || isPublishing || scheduleForLater || (!platformsLoading && selectedPlatforms.length === 0)}
                                        style={{
                                            background: (!aiGeneratedContent.trim() || isPublishing || scheduleForLater || (!platformsLoading && selectedPlatforms.length === 0))
                                                ? '#cccccc'
                                                : '#2e3192',
                                            border: 'none',
                                            borderRadius: '20px',
                                            padding: '8px 24px',
                                            color: 'white',
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            cursor: (!aiGeneratedContent.trim() || isPublishing || scheduleForLater || (!platformsLoading && selectedPlatforms.length === 0)) ? 'not-allowed' : 'pointer',
                                            transition: 'all 0.3s ease'
                                        }}
                                    >
                                        {isPublishing 
                                            ? (platformsLoading ? 'Loading...' : `Publishing${selectedPlatforms.length > 0 ? ` to ${selectedPlatforms.map(code => {
                                                const platform = enabledPlatforms.find(p => p.code === code);
                                                return platform ? platform.name : code;
                                            }).join(' & ')}` : '...'}`)
                                            : (platformsLoading ? 'Loading...' : selectedPlatforms.length > 0 
                                                ? formatPlatformNamesForButton(selectedPlatforms.map(code => {
                                                    const platform = enabledPlatforms.find(p => p.code === code);
                                                    return platform || { name: code, code: code };
                                                }))
                                                : 'Select Platform')
                                        }
                        </button>

                                    <button
                                        onClick={handleSchedulePost}
                                        disabled={!aiGeneratedContent.trim() || isScheduling || !scheduleForLater || !scheduledDate || (!platformsLoading && selectedPlatforms.length === 0)}
                                        style={{
                                            background: (!aiGeneratedContent.trim() || isScheduling || !scheduleForLater || !scheduledDate || (!platformsLoading && selectedPlatforms.length === 0))
                                                ? '#cccccc'
                                                : '#2e3192',
                                            border: 'none',
                                            borderRadius: '20px',
                                            padding: '8px 24px',
                                            color: 'white',
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            cursor: (!aiGeneratedContent.trim() || isScheduling || !scheduleForLater || !scheduledDate || (!platformsLoading && selectedPlatforms.length === 0)) ? 'not-allowed' : 'pointer',
                                            transition: 'all 0.3s ease'
                                        }}
                                    >
                                        {isScheduling 
                                            ? (platformsLoading ? 'Loading...' : `Scheduling${selectedPlatforms.length > 0 ? ` to ${selectedPlatforms.map(code => {
                                                const platform = enabledPlatforms.find(p => p.code === code);
                                                return platform ? platform.name : code;
                                            }).join(' & ')}` : '...'}`)
                                            : (platformsLoading ? 'Loading...' : selectedPlatforms.length > 0 
                                                ? formatPlatformNamesForButton(selectedPlatforms.map(code => {
                                                    const platform = enabledPlatforms.find(p => p.code === code);
                                                    return platform || { name: code, code: code };
                                                })).replace('Post to ', 'Schedule to ')
                                                : 'Select Platform')
                                        }
                                    </button>
                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* Holiday Selection Modal */}
                <Modal show={showHolidayModal} onHide={() => setShowHolidayModal(false)} size="md" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <FontAwesomeIcon icon={faLightbulb} style={{ color: '#2e3192', marginRight: '8px' }} />
                            Select Holiday
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ maxHeight: '400px', overflowY: 'auto', padding: '16px' }}>
                        {holidayOptions.length > 0 ? (
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '8px'
                            }}>
                                {holidayOptions.map((holiday, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            padding: '12px',
                                            cursor: 'pointer',
                                            border: '1px solid #e0dfdc',
                                            borderRadius: '8px',
                                            backgroundColor: '#ffffff',
                                            transition: 'all 0.3s ease',
                                            boxShadow: '0 1px 4px rgba(0, 0, 0, 0.04)'
                                        }}
                                        onClick={() => handleHolidaySelect(holiday)}
                                        onMouseEnter={(e) => {
                                            e.target.style.backgroundColor = '#f8f9fa';
                                            e.target.style.borderColor = '#2e3192';
                                            e.target.style.boxShadow = '0 2px 8px rgba(0, 115, 177, 0.12)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.backgroundColor = '#ffffff';
                                            e.target.style.borderColor = '#e0dfdc';
                                            e.target.style.boxShadow = '0 1px 4px rgba(0, 0, 0, 0.04)';
                                        }}
                                    >
                                        <div style={{
                                            fontWeight: '600',
                                            color: '#000000',
                                            fontSize: '14px',
                                            lineHeight: '1.3'
                                        }}>
                                            {holiday.label}
                            </div>
                          </div>
                                ))}
                </div>
                        ) : (
                            <div style={{
                                padding: '20px',
                                textAlign: 'center',
                                color: '#666666',
                                fontSize: '14px'
                            }}>
                                <FontAwesomeIcon icon={faLightbulb} style={{ fontSize: '24px', marginBottom: '8px', opacity: 0.5 }} />
                                <div style={{ fontSize: '14px', fontWeight: '600', marginBottom: '4px' }}>No holidays available</div>
                                <div style={{ fontSize: '12px', opacity: 0.7 }}>
                                    Please select a country in user preferences first.
                                </div>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowHolidayModal(false)}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Image Preview Modal */}
                <Modal show={isImageModalOpen} onHide={() => setIsImageModalOpen(false)} size={isMaximized ? "xl" : "lg"} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Image Preview</Modal.Title>
                    </Modal.Header>
                <Modal.Body className="text-center">
                        <img
                            src={selectedImageUrl}
                            alt="Selected"
                            style={{
                                maxWidth: "100%",
                                maxHeight: isMaximized ? "90vh" : "70vh",
                                objectFit: "contain",
                            }}
                        />
                </Modal.Body>
                <Modal.Footer>
                        <Button variant="secondary" onClick={() => setIsImageModalOpen(false)}>
                        Close
                    </Button>
                        <Button variant="primary" onClick={() => setIsMaximized(!isMaximized)}>
                            {isMaximized ? "Minimize" : "Maximize"}
                        </Button>
                        <Button variant="success" onClick={() => {
                            handleSelectSuggestedImage(selectedImageUrl);
                            setIsImageModalOpen(false);
                        }}>
                            Select Image
                    </Button>
                </Modal.Footer>
            </Modal>
            </SideNavbar>
        </div>
    );
};

export default ExceptionalScheduleForm;
